import { FormikTouched, FormikValues } from "formik";
import React, { ChangeEvent } from "react";

export type SelectOption = {
  label: string;
  value: string | number;
};

export type SelectProps = {
  label?: string;
  name?: string;
  value?: string | number;
  placeholder?: string;
  className?: string;
  parentClassName?: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  options: SelectOption[];
  disabled?: boolean;
  touched?: FormikTouched<FormikValues>;
  errors?: any;
};

const Select: React.FC<SelectProps> = ({ label, name = "", value, onChange, onBlur, placeholder = "Select an option", className = "", parentClassName = "", options, touched, errors, disabled }) => {
  return (
    <div className={parentClassName}>
      {label && (
        <label className="font-bold text-sm" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="mt-1">
        <select name={name} value={value} onChange={onChange} onBlur={onBlur} disabled={disabled} className={`appearance-none border focus:ring-2 focus:outline-none focus:ring-black rounded w-full py-3 pl-5 px-3 min-h-12 bg-white text-gray-700 leading-tight focus:shadow-outline ${className}`}>
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {touched?.[name] && errors?.[name] && <p className="text-red-600 font-semibold text-sm mt-1">{errors[name]}</p>}
    </div>
  );
};

export default Select;
